export default __webpack_public_path__ + "static/media/oscer-gif_desktop_large.29c918c2.mp4";